import { useEffect } from "react";
import "./AtQueuePopUp.css";

export default function AtQueuePopUp({ message, type, onClose, onLineButtonClick, waitlist }) {
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  if (!message) return null;

  // Split message by lines
  const lines = message.split("\n");

  return (
    <div className="popupOverlay" onClick={onClose}>
      <div className={`popupBox ${type}`} onClick={(e) => e.stopPropagation()}>
        {type === "info" && waitlist && waitlist.length > 0 ? (
          <div className="queueButtonList">
            {waitlist.map((user, idx) => (
              <div key={user.id || idx} className="queueButtonRow">
                <span>{`${idx + 1}. ${user.name}`}</span>
                <div className="queueButtonActions">
                  <button
                    className="queueActionButton check"
                    onClick={() => onLineButtonClick(user.id, "approve")}
                    title="Approve"
                  >
                    ✓
                  </button>
                  <button
                    className="queueActionButton reject"
                    onClick={() => onLineButtonClick(user.id, "reject")}
                    title="Reject"
                  >
                    ✗
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>{message}</p>
        )}
        <button className="closeButton" onClick={onClose}>OK</button>
      </div>
    </div>
  );
}